import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

class BannerSlider {
  private app: HTMLElement;
  private nextButton: HTMLButtonElement;
  private prevButton: HTMLButtonElement;
  constructor(app: HTMLElement) {
    this.app = app;
    this.nextButton = this.app.querySelector('.swiper-button-next');
    this.prevButton = this.app.querySelector('.swiper-button-prev');

    this.init();
  }

  init(): void {
    new Swiper(this.app, {
      modules: [A11y, Navigation],
      a11y: {
        enabled: true,
      },
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
    });
  }
}

document.querySelectorAll('[banner-slideshow]').forEach((bannerSlider) => {
  new BannerSlider(bannerSlider as HTMLElement);
});
